// src/pages/RegisterPage/GoogleCallbackPage.tsx

import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const GoogleCallbackPage: React.FC = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const { login } = useAuth();
    
    useEffect(() => {
        // SECURITY: token agora vem no URL fragment (#token=...) em vez de query string,
        // para não vazar em logs/Referer/histórico. Mantém fallback para ?token= por compat.
        const hashParams = new URLSearchParams(window.location.hash.startsWith('#') ? window.location.hash.slice(1) : '');
        const token = hashParams.get('token') || searchParams.get('token');
        const verificationStatus = searchParams.get('status');
        const email = searchParams.get('email');
        const error = searchParams.get('error');

        // Limpa o fragment imediatamente para não ficar no histórico/copiável
        if (window.location.hash) {
            try { window.history.replaceState(null, '', window.location.pathname + window.location.search); } catch {}
        }

        // Detecta se esta página está dentro de um popup (tem window.opener)
        const isPopup = window.opener && window.opener !== window;

        if (isPopup) {
            // === MODO POPUP: COMUNICA COM A JANELA PAI E FECHA ===
            // SEGURANÇA: usar window.location.origin como targetOrigin em vez
            // de '*'. Isso garante que a mensagem só é entregue a uma janela
            // na MESMA origem (clydes.com.br), bloqueando exfiltração de
            // token caso o popup seja aberto em origem hostil.
            const targetOrigin = window.location.origin;
            if (token) {
                window.opener.postMessage({ type: 'GOOGLE_LOGIN_SUCCESS', payload: { token } }, targetOrigin);
            } else if (verificationStatus === 'verification_sent') {
                window.opener.postMessage({ type: 'GOOGLE_VERIFICATION_SENT', payload: { email } }, targetOrigin);
            } else if (error) {
                window.opener.postMessage({ type: 'GOOGLE_LOGIN_ERROR', payload: { error } }, targetOrigin);
            }
            // Fecha o popup
            window.close();
        } else {
            // === MODO FULLSCREEN (FALLBACK) ===
            // Caso o usuário abra o link direto ou o popup blocker tenha forçado nova aba
            if (token) {
                login(token);
                navigate('/', { replace: true });
            } else if (error) {
                // Redireciona para login com erro
                navigate('/?loginError=' + error, { replace: true });
            } else if (verificationStatus) {
                // Redireciona para login mas com status de verificação (precisaria tratar na Home ou Login)
                navigate('/', { replace: true });
            }
        }
    }, [searchParams, login, navigate]);

    return (
        <div style={{
            background: '#000', 
            height: '100vh', 
            width: '100vw', 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center',
            color: 'white',
            flexDirection: 'column'
        }}>
            <p>Processando autenticação...</p>
        </div>
    );
};

export default GoogleCallbackPage;